import { render, staticRenderFns } from "./articleDetail.vue?vue&type=template&id=490975f5&"
import script from "./articleDetail.vue?vue&type=script&lang=js&"
export * from "./articleDetail.vue?vue&type=script&lang=js&"
import style0 from "./articleDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports